module.exports = __webpack_public_path__ + "static/media/unpaid.d4ba17d5.svg";